import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApiClient } from './api/client';
import { createTransport, resolveApiMode } from './api/mode';
import { App } from './app/App';
import { PlatformProvider } from './app/platform';
import { AuthBoundary, runAuthBootstrap } from './auth/AuthBoundary';
import { getAccessToken, reauthenticate } from './auth/session';
import './styles/tokens.css';
import './styles/app.css';

async function start() {
  const container = document.getElementById('root');
  if (!container) throw new Error('#root がありません');

  // 認証の初期化が終わるまで描画しない。/auth/callback のcodeをReactの外で
  // 1回だけ交換するため（runAuthBootstrapのコメント参照）。
  const auth = await runAuthBootstrap();
  const authEnabled = auth.status === 'ready';

  // fixtureは明示指定のときだけ。実APIが失敗しても自動でfixtureへ切り替えない。
  const mode = resolveApiMode();
  // 認証が無効なときはtokenの取得元を渡さない。Authorizationも401の再ログインも起きない。
  const transport = await createTransport(
    mode,
    authEnabled ? { getAccessToken, reauthenticate } : undefined,
  );

  createRoot(container).render(
    <StrictMode>
      <AuthBoundary result={auth}>
        <PlatformProvider value={{ api: new ApiClient(transport), mode, actorId: 'local-user' }}>
          <App authEnabled={authEnabled} />
        </PlatformProvider>
      </AuthBoundary>
    </StrictMode>,
  );
}

void start();
